import React from 'react';
import './App.css';
import { Provider } from 'react-redux';
import { createAppStore } from './store';
import Component from './components/Component';
import { HashRouter, BrowserRouter } from 'react-router-dom';
import { Config } from '.';
import SearchModule from './components/SearchModule/SearchModule';
import ReactDOM from 'react-dom';
import UserModule from './components/UserModule/UserModule';

const App: React.FC<{config: Config}> = props => {
	return (
		<Provider store={createAppStore()}>
			<BrowserRouter>
				<Component config={props.config} />
			</BrowserRouter>

			{ReactDOM.createPortal(<SearchModule />, document.getElementById('root-search'))}
			{ReactDOM.createPortal(<UserModule />, document.getElementById('root-user'))}
		</Provider>
	);
}

export default App;
